// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pp_a bhs_ea bhs_ke bhs_ju bhs_a bhs_j bhs_so bhs_sp","SearchPanel__icon":"pp_b bhs_vo bhs_hi bhs_su bhs_va","SearchPanel__input":"pp_c bhs_jb bhs_eg bhs_z"};